import React from 'react';
import { connect } from 'react-redux';
import { deleteSyncScores } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteSyncScores,
};

function ModalDeleteSyncScore({ deleteSyncScores, data, closeModal }) {
  const auth = data?.auth;
  const item = data?.item;
  const id = data?.id;
  const history = data?.history;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteSyncScores({ auth, history, id, values: item });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 600 ? 600 : screenWidth}
    >
      <div className='flex justify-around flex-column align-start'>
        <p className='is-size-6 mt-5 mb-3 mx-5'>
          Apakah Anda yakin ingin menghapus status{' '}
          <span className='has-text-danger has-text-weight-semibold'>
            Sync Nilai
          </span>
          ?
        </p>
        <div className='flex flex-column justify-start mx-5 my-3'>
          <p className='is-size-6 is-italic mb-2'>
            <span className='tag is-info is-light is-rounded'>Note:</span>
          </p>
          <ol className='mx-4' style={{fontSize: 13}}>
            <li>
              Jika status sync nilai dihapus, sync nilai akan bisa dilakukan
              lagi dan tidak menghapus sync nilai yang telah dilakukan.
            </li>
            <li>
              Hapus manual nilai sebelumnya jika ingin melakukan sync nilai
              lagi, menghindari duplikat nilai.
            </li>
            <li>
              Jika dilakukan sync nilai kembali, kolom nilai yang terisi adalah
              kolom nilai yang masih kosong.
            </li>
          </ol>
        </div>
      </div>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteSyncScore);
